import React, { useCallback, useState } from "react";

import { Col, Container, Row } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import AccountInformation from "./AccountInformation";
import Payment from "./Payment";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

const onboardingInfo = [
  {
    title: "Make a great first impression",
    description:
      "You don't have to be a designer to have a beautiful digital menu. SproutQR does the hard work for you.",
  },
  {
    title: "Always be up-to-date",
    description:
      "Don't disappoint your customers with an outdated menu full of 86'd items. SproutQR  takes less than a minute to update.",
  },
  {
    title: "Go Touchless with QR codes",
    description:
      "SproutQR uses ... QR codes. That means your customers can easily view them on their personal devices.",
  },
];

const ELEMENTS_OPTIONS = {
  fonts: [
    {
      family: "Roboto",
      src: `url("${process.env.REACT_APP_FONTS_URL}Roboto.woff") format("woff")`,
    },
  ],
};

const Onboarding = () => {
  const [complete, setComplete] = useState(false);

  const handleCompleteAccountInfo = useCallback(() => {
    setComplete(true);
  }, []);

  return (
    <Container>
      <Row>
        <Col className="onboarding-info px-3" lg={6} md={12}>
          <p className="onboarding-title">
            QR Code Menus for Restaurants & Bars
          </p>
          {onboardingInfo.map(({ title, description }, index) => (
            <div key={index} className="onboarding-description-wrapper">
              <p className="onboarding-description-bold">{title}</p>
              <p className="onboarding-description">{description}</p>
            </div>
          ))}
        </Col>
        <Col className="px-3" lg={6} md={12}>
          {complete ? (
            <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
              <Payment />
            </Elements>
          ) : (
            <AccountInformation onSubmit={handleCompleteAccountInfo} />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Onboarding;
